// extracted by mini-css-extract-plugin
export default {"wrapper":"estimates-price-block-module__wrapper--ffo","units":"estimates-price-block-module__units--WfK","unavailable":"estimates-price-block-module__unavailable--bB4"};